import React from "react";

import InvoiceImage from "../../../assets/media/invoice.png"
import "./index.css";

const AddBusinessInfoDialog = ({ goBrandInfo }) => (
  <div
    className="modal fade add-commercial-user-dialog"
    id="add_business_info_dialog"
    tabIndex="-1"
    role="dialog"
    aria-labelledby="modal-default-fadein"
    aria-hidden="true"
  >
    <div className="modal-dialog" role="document">
      <div className="modal-content add-commercial-user-content">
        <div className="modal-body pb-1 add-commercial-user-dialog-body">
          <img src={InvoiceImage} width="70" alt="icon" />
          <p>
            Your Ecosystem business development manager will set your plan
            metric and then you can proceed with your contract.
          </p>
          <button
            type="button"
            className="btn btn-yellow"
            onClick={goBrandInfo}
            data-dismiss="modal"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default AddBusinessInfoDialog;



// WEBPACK FOOTER //
// ./src/screens/UserPlatform/AddBusinessInfoDialog/index.js